export default "__VITE_ASSET__NxaUBQ8y__"